import React from "react";

export default function Policy() {
  return (
    <div>
      <p class="p1">1. TERMS AND CONDITIONS</p>
      <p class="p2">
        <br />
      </p>
      <p class="p2">
        <br />
      </p>
      <p class="p1">
        1.1. Application - Mobile application "Autoinfo Yerevan," designed for
        mobile devices based on iOS and Android for transmitting messages
        between registered car owners - Users of the Application.
      </p>
      <p class="p2">
        <br />
      </p>
      <p class="p1">
        1.2 User Account - the account created by the User, which is a
        collection of data, statistics, accounts and other information about the
        User necessary for the User to use the Application functionality in
        accordance with this Agreement, namely: authorization (authentication)
        of the User in the mobile application, access to information about the
        User, program settings and other similar information.
      </p>
      <p class="p2">
        <br />
      </p>
      <p class="p1">
        1.3 Account of the User - the personal section of the User in the
        Application associated with the Account of the User.
      </p>
      <p class="p2">
        <br />
      </p>
      <p class="p1">
        1.4. Personal information of the User - any information that the User
        provides about himself or herself when registering (creating the
        Account/Account of the User) or in the course of using the Application,
        as well as information that is automatically transmitted to the
        Rightholder during the Application using the software installed on the
        User's device, including IP address, information from cookies, data
        about the User's actions in the Application, as well as other data about
        the User.
      </p>
      <p class="p2">
        <br />
      </p>
      <p class="p1">
        1.5 Content of the Appendix - a set of Information placed in the
        Appendix. All Information posted by the Rightholder in the Appendix, as
        well as the selection, grouping and location of the Information, is the
        intellectual property of the Rightholder and (or) other Rightholders,
        the Information posted by the Users is the intellectual property of the
        Users and (or) other Rightholders.
      </p>
      <p class="p2">
        <br />
      </p>
      <p class="p1">
        1.6 Blocking - temporary termination of access of the User to the
        resources of the Application, in some cases with prohibition of
        Authorization.
      </p>
      <p class="p2">
        <br />
      </p>
      <p class="p1">
        1.7. Authorization - identification of the User by entering credentials
        into the corresponding fields in the Application in order to obtain
        access of the User to the Application Services.
      </p>
    </div>
  );
}
